import type { ValuesOf } from '@shared/types';

export const SearchEntity = {
  Artworks: 'artworks',
  Artists: 'artists',
  Selections: 'selections',
} as const;

export type SearchEntity = ValuesOf<typeof SearchEntity>;
